/**
 * @deprecated static version, use root/toggleTheme instead for SSR
 */
export function toggleTheme() {
  if (import.meta.client) {
    const classList = Array.from(document.documentElement.classList)
    if (Array.isArray(classList)) {
      if (classList.includes('dark')) {
        document.documentElement.classList.remove('dark')
        document.documentElement.classList.add('light')
      } else {
        document.documentElement.classList.remove('light')
        document.documentElement.classList.add('dark')
      }
    } else {
      document.documentElement.classList.add('dark')
    }
  }
}

export const boolify = (bool: string): boolean => (bool ? bool.toLowerCase() === 'true' : false)

export const capitalize = (str: string | undefined): string => {
  return typeof str === 'string' ? str.replace(/\b\w/g, (char) => char.toUpperCase()) : ''
}
